import { Project } from '../types';

const project: Project = {
  slug: 'neptuno-residential',
  accessPin: '2244',
  qrTickets: ['N4K7P2'],
  info: {
    id: 2,
    title: 'Neptuno Residential',
    category: {
      'en-US': 'Residential',
      'es-MX': 'Residencial',
    },
    year: 2024,
    location: 'Cabo San Lucas, B.C.S',
    floor: '4 floors',
    building: '912.26aZA-',
    cover: '/images/Cover2.webp',
    description: {
      'en-US':
        'This residential project blends modern lines with warm, natural finishes. Bright interiors connect seamlessly to the outdoors through large windows, enhancing light and airflow. Open living spaces promote interaction, while bedrooms offer privacy and tranquility. The minimalist facade, noble materials, and subtle landscaping create a timeless, elegant, and functional living environment.',
      'es-MX':
        'Este proyecto residencial combina lineas modernas con acabados naturales y calidos. Los interiores luminosos conectan con el exterior mediante grandes ventanales, mejorando la luz y la ventilacion. Los espacios abiertos fomentan la convivencia, mientras las recamaras ofrecen privacidad y calma. La fachada minimalista, los materiales nobles y el paisajismo sutil crean un ambiente atemporal, elegante y funcional.',
    },
  },
  assets: {
    images: [
      { file: '2.1', ext: 'webp' },
      { file: '2.2', ext: 'webp' },
      { file: '2.3', ext: 'webp' },
      { file: '2.4', ext: 'webp' },
      { file: '2.5', ext: 'webp' },
      { file: '2.6', ext: 'webp' },
      { file: '2.7', ext: 'webp' },
    ],
    videos: [],
    panos: [],
  },
};

export default project;
